module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message-wrap"
  }, [_c('h1', {
    staticClass: "personal-center-form__title"
  }, [_vm._v("消息")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content
    },
    on: {
      "row-dblclick": _vm.toMsgdeatils
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "发送人",
      "align": "center",
      "min-width": "20"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "tip"
        }, [_vm._v("系统信息"), _c('i', {
          class: scope.row.state == '未读' ? 'red-point' : ''
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "信息",
      "align": "center",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sendTime",
      "label": "时间",
      "align": "center",
      "min-width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "min-width": "20"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleClick(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.pup(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.content.length > 1) ? _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "page-size": 10,
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1320f900"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/message.vue
// module id = 1052
// module chunks = 1